import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchGetAdminPaymentMethod } from '../../../../actions/admin';
import InputWrapper from '../../../common/InputWrapper';
import styled from '@emotion/styled';

const TableContainer = styled('div')`
  padding: 0 !important;
`;

const PaymentMethod = (props) => {
  const { values, handleChangeInput, handleSubmit } = props;
  const { paymentMethod } = useSelector((state) => state.admin);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchGetAdminPaymentMethod());
  }, []);

  return (
    <>
      <div className="border-bottom">
        <h4 className="header-title">Оплата</h4>
      </div>
      <TableContainer>
        {values && (
          <div className="fixed-table-container">
            <div className="fixed-table-body">
              <table className="table table-centered">
                <thead className="thead-light">
                  <tr>
                    <th>Код</th>
                    <th>Название</th>
                    <th>Системный способ оплаты</th>
                  </tr>
                </thead>
                <tbody>
                  {values.paymentMethod &&
                    values.paymentMethod?.map((item, index) => (
                      <tr key={item.uid}>
                        <td style={{ width: '400px' }}>
                          <div className="font-weight-bold">
                            <InputWrapper
                              type="text"
                              id="code"
                              value={item.code ? item.code : ''}
                              onChange={(e) =>
                                handleChangeInput(`paymentMethod.${index}.code`, e.target.value)
                              }
                            />
                          </div>
                        </td>
                        <td>
                          <div className="text-muted">
                            <InputWrapper
                              type="text"
                              id="name"
                              value={item.name ? item.name : ''}
                              onChange={(e) =>
                                handleChangeInput(`paymentMethod.${index}.name`, e.target.value)
                              }
                            />
                          </div>
                        </td>
                        <td style={{ width: '400px' }}>
                          <div>
                            <InputWrapper
                              type="text"
                              id="paymentMethod"
                              value={item.paymentMethod ? item.paymentMethod : ''}
                              onChange={(e) =>
                                handleChangeInput(
                                  `paymentMethod.${index}.paymentMethod`,
                                  e.target.value,
                                )
                              }
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </TableContainer>
    </>
  );
};

export default PaymentMethod;
